import React, { useEffect, useState } from "react";
import EditButtonConfig from "../../components/EditComponents/EditButtonConfig";
import EditHtmlContent from "../../components/EditComponents/EditHtmlContent";
import EditSpacer from "../../components/EditComponents/EditSpacer";
import EditImageConfig from "../../components/EditComponents/EditImageConfig";
import EditLabel from "../../components/EditComponents/EditLabel";
import EditTabView from "../../components/EditComponents/EditTabView";
import { useScreenContext } from "../../context/ScreenContext";
import EditFormBlock from "../../components/EditComponents/EditFormBlock";
import EditButtonGroup from "../../components/EditComponents/EditButtonGroup";
import BasicStyleEditor from "../../components/BuilderComponents/BasicStyleEditor";
import CustomCss from "../../components/BuilderComponents/CustomCss";
import BuilderTabs from "../../Layouts/BuilderTabs";
import EditDropdownNavigate from "../../components/EditComponents/EditDropdownNavigate";
import EditPositionedTab from "../../components/EditComponents/EditPositionedTab";
import EditProgressTracker from "../../components/EditComponents/EditProgressTracker";
import { useAppBlocksContext } from "../../context/AppBlocksContext";

const EditScreenField = ({ editElementRightsidebar, saveElement, device }) => {
  const [editElementData, setEditElementData] = useState(editElementRightsidebar.config);
  const { nestedGridData, currentScreenData } = useScreenContext();
  const { applicationBlockData } = useAppBlocksContext();

  const updateClassAndInlineStyle = (data) => {
    setEditElementData({ ...editElementData, className: data.classData, inline_style: data.inlineData });
  };
  const handleEditElementData = (type, data) => {
    setEditElementData({ ...editElementData, [type]: data });
  };
  useEffect(() => {
    if (
      !editElementData ||
      editElementData.type === "html" ||
      editElementData.type === "form" ||
      editElementData.type === "button" ||
      editElementData.type === "dropdown"
    )
      return;
    saveElement(editElementData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementData]);
  const getEditElementRightsidebar = () => {
    switch (editElementRightsidebar.type) {
      case "button":
      case "dropdown":
        return (
          <div style={{ width: "384px" }}>
            <EditButtonConfig
              editElementRightsidebar={editElementRightsidebar}
              onSave={(data) => {
                saveElement(data);
              }}
              places="screen"
              device={device}
              smId={currentScreenData?.screen_settings?.table_id || ""}
            />
          </div>
        );
      case "button-group":
        return (
          <EditButtonGroup
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            elements={editElementRightsidebar.elements}
            smId={currentScreenData?.screen_settings?.table_id || ""}
            device={device}
            places="screen"
          />
        );
      case "html":
        return (
          <EditHtmlContent
            editElementData={editElementData}
            setEditElementData={saveElement}
            places="screen"
            element="button"
            device={device}
            tableID={currentScreenData?.screen_settings?.table_id || ""}
          />
        );
      case "spacer":
        return <EditSpacer editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "image":
        return <EditImageConfig editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "label":
        return <EditLabel editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "progress-tracker":
        return (
          <EditProgressTracker
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={applicationBlockData.config.layout.table_id || ""}
          />
        );
      case "form":
        return (
          <div style={{ width: "384px" }}>
            <EditFormBlock
              editElementData={editElementData}
              setEditElementData={saveElement}
              device={device}
              elements={editElementRightsidebar.elements}
              tableID={currentScreenData?.screen_settings?.table_id || ""}
              places="screen"
            />
          </div>
        );
      case "tabview":
        return (
          <EditTabView
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            nestedGridData={nestedGridData}
          />
        );
      case "tab":
        return <EditPositionedTab editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "dropdown-navigate":
        return (
          <EditDropdownNavigate
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            device={device}
          />
        );
      default:
        return (
          <div>
            <h3 style={{ fontSize: "14px", color: "#10182b", fontWeight: "600" }}>Edit not available</h3>
          </div>
        );
    }
  };
  const tabData = [
    {
      label: "Basic",
      content: (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer">
          {editElementData && getEditElementRightsidebar()}
        </div>
      )
    },
    {
      label: "Style",
      content: (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ paddingTop: "0px" }}>
          <BasicStyleEditor
            value={{
              classData: editElementData?.className || {},
              inlineData: editElementData?.inline_style || {}
            }}
            callbackFunction={updateClassAndInlineStyle}
            fieldType={editElementData?.type || ""}
          />
        </div>
      )
    },
    {
      label: "Advanced",
      content: (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer">
          <AdvanceEditForScreenElement editElementData={editElementData} onChange={handleEditElementData} />
        </div>
      )
    }
  ];

  const returnTypeBasedEditComponents = () => {
    const excludedTypes = ["button", "button-group", "html", "form", "spacer", "dropdown-navigate", "tab"];

    if (excludedTypes.includes(editElementRightsidebar?.type)) {
      return (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ padding: "0px", gap: "0px" }}>
          {editElementData && getEditElementRightsidebar()}
        </div>
      );
    } else {
      return <BuilderTabs tabs={tabData} />;
    }
  };

  useEffect(() => {
    setEditElementData(editElementRightsidebar.config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementRightsidebar.id]);

  return <div>{returnTypeBasedEditComponents(editElementRightsidebar.type)}</div>;
};

const AdvanceEditForScreenElement = ({ editElementData, onChange }) => {
  const excludedTypes = ["button", "dropdown", "button-group", "html", "dynamic-html", "file_viewer"];
  if (excludedTypes.includes(editElementData.type)) return;
  return (
    <>
      <CustomCss
        value={{
          custom_css: editElementData.custom_css || "",
          custom_id: editElementData.custom_id || "",
          custom_classname: editElementData.custom_classname || ""
        }}
        onChange={(e) => onChange(e.target.name, e.target.value)}
      />
    </>
  );
};

export default EditScreenField;
